import { FormattedMessage, injectIntl } from 'react-intl';
import { Box } from '@mui/material';
import getMessage from '../../utils/getMessage';
import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { getAnnouncementsState } from '../../store/selectors/news';

const UserNotificationPanel = () => {

  const generalAnnouncements = useSelector(state => getAnnouncementsState(state));
  const language = useSelector(state => state.language);

  return (
    <Fragment>
      <div>
        <h2><FormattedMessage id='userNotifications'/></h2>
        <Box sx={{ width: '100%', typography: 'body1' }}>
          { generalAnnouncements?.length > 0 && 
            <div className="user-notifications-container">
              <div className="pad-horizontal">
              <h3><FormattedMessage id='generalAnnouncements'/></h3>
              </div>
              <ul>
              {
                generalAnnouncements.map(n => 
                  <li key={n.id} className="pad-horizontal">
                    <article className="general-annoucement">
                      <h1>{n.i18n[language].title}&nbsp;</h1>
                      <p>{n.i18n[language].content}</p>
                    </article>
                  </li>
                )
              }
              </ul>
            </div>
          }
        </Box>
      </div>
    </Fragment>
  );
};

export default injectIntl(UserNotificationPanel);